export const DEFAULT_MAP_ID = "a7e2dbd01b9a18afb82d00c6";

export const normalizeCoordinate = (value) => {
    if (typeof value === "function") value = value();
    if (value === null || value === undefined || value === "") return null;

    const parsedValue = typeof value === "string"
        ? Number(value.trim().replace(",", "."))
        : Number(value);

    return Number.isFinite(parsedValue) ? parsedValue : null;
}
